export type SocialNetwork =
  | "linkedin"
  | "instagram"
  | "twitter"
  | "facebook";

export interface CompanyConfig {
  label: string;
  logoPath: string;
  logoWidth: number;
  logoHeight: number;
  address: string;
  mapsUrl: string;
  websiteUrl: string;
  websiteLabel: string;
  socialLinks: Partial<Record<SocialNetwork, string>>;
}

export const SOCIAL_NETWORK_ORDER: SocialNetwork[] = [
  "linkedin",
  "instagram",
  "twitter",
  "facebook",
];

const OM_WEBSITE_URL = "https://omnicommedia.com/";
const OM_WEBSITE_LABEL = "omnicommedia.com";
const OM_LINKEDIN_URL = "https://br.linkedin.com/company/omnicommedia-brazil";
const OM_INSTAGRAM_URL = "https://www.instagram.com/omnicommediagroup/";
const OUTPROMO_LINKEDIN_URL = "https://www.linkedin.com/company/outpromo/";
const OUTPROMO_INSTAGRAM_URL = "https://www.instagram.com/outpromoagency/";
const DRUM_LINKEDIN_URL = "https://br.linkedin.com/company/agenciadrum";
const DRUM_INSTAGRAM_URL = "https://www.instagram.com/agenciadrum/";
const FLYWHEEL_LINKEDIN_URL = "https://br.linkedin.com/showcase/flywheellatam/";
const FREI_CANECA_MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Rua+Frei+Caneca%2C+1355%2C+Sao+Paulo%2C+SP";
const BARAO_DE_SURUI_MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Rua+Barao+de+Surui%2C+143%2C+Sao+Paulo%2C+SP";
const DEFAULT_LOGO_WIDTH = 232;
const DEFAULT_LOGO_HEIGHT = 48;
const DEFAULT_LOGO_SIZE = {
  logoWidth: DEFAULT_LOGO_WIDTH,
  logoHeight: DEFAULT_LOGO_HEIGHT,
};

export const COMPANY_ORDER = [
  "creo",
  "drum",
  "flywheel",
  "fuse",
  "initiative",
  "om",
  "omd",
  "outpromo",
  "phd",
  "um",
] as const;

export type CompanyKey = typeof COMPANY_ORDER[number];

export const COMPANIES: Record<CompanyKey, CompanyConfig> = {
  om: {
    label: "OM",
    logoPath: "/logos/om.png",
    ...DEFAULT_LOGO_SIZE,
    address: "Rua Frei Caneca, 1355",
    mapsUrl: FREI_CANECA_MAPS_URL,
    websiteUrl: OM_WEBSITE_URL,
    websiteLabel: OM_WEBSITE_LABEL,
    socialLinks: {
      linkedin: OM_LINKEDIN_URL,
      instagram: OM_INSTAGRAM_URL,
    },
  },
  outpromo: {
    label: "OUTPROMO",
    logoPath: "/logos/outpromo.png",
    ...DEFAULT_LOGO_SIZE,
    address: "Rua Barão de Suruí, 143",
    mapsUrl: BARAO_DE_SURUI_MAPS_URL,
    websiteUrl: "https://outpromo.com.br/",
    websiteLabel: "outpromo.com.br",
    socialLinks: {
      linkedin: OUTPROMO_LINKEDIN_URL,
      instagram: OUTPROMO_INSTAGRAM_URL,
    },
  },
  fuse: {
    label: "FUSE",
    logoPath: "/logos/fuse.png",
    ...DEFAULT_LOGO_SIZE,
    address: "Rua Barão de Suruí, 143",
    mapsUrl: BARAO_DE_SURUI_MAPS_URL,
    websiteUrl: OM_WEBSITE_URL,
    websiteLabel: OM_WEBSITE_LABEL,
    socialLinks: {
      linkedin: OM_LINKEDIN_URL,
      instagram: OM_INSTAGRAM_URL,
    },
  },
  creo: {
    label: "CREO",
    logoPath: "/logos/creo.png",
    ...DEFAULT_LOGO_SIZE,
    address: "Rua Frei Caneca, 1355",
    mapsUrl: FREI_CANECA_MAPS_URL,
    websiteUrl: OM_WEBSITE_URL,
    websiteLabel: OM_WEBSITE_LABEL,
    socialLinks: {
      linkedin: OM_LINKEDIN_URL,
      instagram: OM_INSTAGRAM_URL,
    },
  },
  omd: {
    label: "OMD",
    logoPath: "/logos/omd.png",
    ...DEFAULT_LOGO_SIZE,
    address: "Rua Frei Caneca, 1355",
    mapsUrl: FREI_CANECA_MAPS_URL,
    websiteUrl: OM_WEBSITE_URL,
    websiteLabel: OM_WEBSITE_LABEL,
    socialLinks: {
      linkedin: OM_LINKEDIN_URL,
      instagram: OM_INSTAGRAM_URL,
    },
  },
  phd: {
    label: "PHD",
    logoPath: "/logos/phd.png",
    ...DEFAULT_LOGO_SIZE,
    address: "Rua Frei Caneca, 1355",
    mapsUrl: FREI_CANECA_MAPS_URL,
    websiteUrl: OM_WEBSITE_URL,
    websiteLabel: OM_WEBSITE_LABEL,
    socialLinks: {
      linkedin: OM_LINKEDIN_URL,
      instagram: OM_INSTAGRAM_URL,
    },
  },
  initiative: {
    label: "INITIATIVE",
    logoPath: "/logos/initiative.png",
    ...DEFAULT_LOGO_SIZE,
    address: "Rua Frei Caneca, 1355",
    mapsUrl: FREI_CANECA_MAPS_URL,
    websiteUrl: OM_WEBSITE_URL,
    websiteLabel: OM_WEBSITE_LABEL,
    socialLinks: {
      linkedin: OM_LINKEDIN_URL,
      instagram: OM_INSTAGRAM_URL,
    },
  },
  um: {
    label: "UM",
    logoPath: "/logos/um.png",
    ...DEFAULT_LOGO_SIZE,
    address: "Rua Frei Caneca, 1355",
    mapsUrl: FREI_CANECA_MAPS_URL,
    websiteUrl: OM_WEBSITE_URL,
    websiteLabel: OM_WEBSITE_LABEL,
    socialLinks: {
      linkedin: OM_LINKEDIN_URL,
      instagram: OM_INSTAGRAM_URL,
    },
  },
  flywheel: {
    label: "FLYWHEEL",
    logoPath: "/logos/flywheel.png",
    ...DEFAULT_LOGO_SIZE,
    address: "Rua Barão de Suruí, 143",
    mapsUrl: BARAO_DE_SURUI_MAPS_URL,
    websiteUrl: OM_WEBSITE_URL,
    websiteLabel: OM_WEBSITE_LABEL,
    socialLinks: {
      linkedin: FLYWHEEL_LINKEDIN_URL,
      instagram: OM_INSTAGRAM_URL,
    },
  },
  drum: {
    label: "DRUM",
    logoPath: "/logos/drum.png",
    ...DEFAULT_LOGO_SIZE,
    address: "Rua Frei Caneca, 1355",
    mapsUrl: FREI_CANECA_MAPS_URL,
    websiteUrl: "https://drumag.com.br/",
    websiteLabel: "drumag.com.br",
    socialLinks: {
      linkedin: DRUM_LINKEDIN_URL,
      instagram: DRUM_INSTAGRAM_URL,
    },
  },
};
